import type { JSONContent } from '@tiptap/core';

import { IconElement } from '@/iconElement';
import { ParagraphElement, type TParagraphElement } from '@/paragraphElement';
import type { SerializableNode } from '@/serializer';
import type { TTextLeaf } from '@/textLeaf';
import { SerializeTextLeaf } from '@/textLeaf';
import type { DreamRenderElementProps } from '@/types';

interface Props {
  isPremium: boolean;
  node: JSONContent & SerializableNode;
  attributes?: DreamRenderElementProps<TParagraphElement>['attributes'];
}

export const PaidContent = ({ node, isPremium, attributes }: Props) => {
  if (!isPremium) {
    return null;
  }

  // @ts-expect-error
  const markAttrs = node?.content?.[0]?.marks?.[0]?.attrs;
  const textNode = {
    text: node?.attrs?.postPaidText || '',
    type: 'text',
    marks: [
      {
        type: 'textStyle',
        attrs: markAttrs,
      },
    ],
  } as TTextLeaf;

  return (
    <ParagraphElement element={node as TParagraphElement} attributes={attributes} as="span">
      <div
        className="flex flex-wrap items-center"
        style={{ gap: node?.attrs?.postPaidText ? (node?.attrs?.postPaidContentGap ?? '4px') : '0px' }}
      >
        <IconElement
          element={{
            type: 'icon',
            attrs: {
              id: '',
              icon: {
                iconName: 'LockSimple',
                iconType: 'phosphor',
              },
              size: node?.attrs?.postPaidContentIconSize || 16,
              fill: node?.attrs?.postPaidIconFill || markAttrs?.color,
              backgroundColor: 'transparent',
              padding: '0px',
              borderRadius: '0px',
              borderWidth: '1px',
              borderColor: '#E5E7EB',
              borderStyle: 'none',
            },
            content: [
              {
                id: '',
                text: '',
              },
            ],
          }}
        >
          {null}
        </IconElement>
        <SerializeTextLeaf leaf={textNode} />
      </div>
    </ParagraphElement>
  );
};
